import { Link } from "react-router-dom";

const BROWSE_LINKS = [
  { label: "电影分类", to: "/category/movie" },
  { label: "电视剧分类", to: "/category/tv" },
  { label: "影视资讯", to: "/category/news" },
  { label: "搜索影视", to: "/search" },
];

const HOT_LINKS = [
  { label: "星际孤旅", to: "/detail/m1" },
  { label: "长夜将明", to: "/detail/t1" },
  { label: "春山书院", to: "/detail/t2" },
  { label: "迷雾追凶", to: "/detail/m3" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-300 mt-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2.5 mb-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center font-heading font-extrabold text-lg">
                奇
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">奇优影院</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300/85">
              奇优影院是面向影视爱好者的资讯与推荐平台，聚合电影、电视剧的最新动态、分类浏览与作品详情，帮你更快找到想看的内容。
            </p>
            <p className="mt-4 text-xs text-background-400">
              本站影视信息均为虚构示例内容，仅用于展示。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-3 font-heading">内容浏览</h3>
            <ul className="space-y-2">
              {BROWSE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300/85 hover:text-secondary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-3 font-heading">热门推荐</h3>
            <ul className="space-y-2">
              {HOT_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300/85 hover:text-secondary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-3 font-heading">联系我们</h3>
            <p className="text-sm text-background-300/85 mb-1">
              邮箱：hello@qiyoucinema.example
            </p>
            <p className="text-sm text-background-300/85 mb-4">
              合作：media@qiyoucinema.example
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: "ri-weibo-line", label: "微博", href: "https://uxszq.cn" },
                { icon: "ri-wechat-line", label: "微信", href: "https://weixin.qq.com" },
                { icon: "ri-tiktok-line", label: "抖音", href: "https://www.douyin.com" },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-8 h-8 rounded-md border border-primary-800 flex items-center justify-center text-background-300 hover:text-accent-400 hover:border-accent-500 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-base w-4 h-4 flex items-center justify-center`} />
                </a>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 mt-4 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
            >
              了解奇优影院
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-primary-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <p className="text-xs text-background-400">
            © 2026 奇优影院 Qiyou Cinema · 内容仅供演示，不提供在线播放服务
          </p>
          <p className="text-xs text-background-400">
            本站信息由编辑整理，片名、演职人员均为虚构示例
          </p>
        </div>
      </div>
    </footer>
  );
}